"use strict";
/**
 * Copyright (c) Hathor Labs and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axiosWrapper_1 = __importDefault(require("./axiosWrapper"));
const config_1 = __importDefault(require("../config"));
/**
 * Create axios instance settings base URL and content type
 * Besides that, it captures error to show modal error and save in Redux
 *
 * @module Axios
 */
/**
 * Create an axios instance to be used when sending requests
 *
 * @param {callback} resolve Callback to be stored and used in case of a retry after a fail
 * @param {number} timeout Timeout in milliseconds for the request
 */
const txMiningRequestClient = (resolve, timeout) => {
    const txMiningURL = config_1.default.getTxMiningUrl();
    const txMiningApiKey = config_1.default.getTxMiningApiKey();
    const headers = {};
    if (txMiningApiKey) {
        headers["apikey"] = txMiningApiKey;
    }
    return axiosWrapper_1.default(txMiningURL, resolve, timeout, headers);
};
exports.default = txMiningRequestClient;
//# sourceMappingURL=txMiningAxios.js.map